import { Button } from "@babybjorn/ui";
import { Script } from "gatsby";
import { useTranslation } from "gatsby-plugin-react-i18next";
import type { FC } from "react";

type BabylistProductDetails = {
	images: string | string[]; // Multiple images allow visitors to choose the image they like best.
	price: string; // Price of the item on your website.
	title: string; // Title of the item include color, size, etc.
	url: string; // URL to direct gift givers to when purchasing this item.
};

declare global {
	interface Window {
		bl?: {
			addToRegistry?: (productDetails: BabylistProductDetails) => void;
		};
	}
}

export const showBabyListButton = () => process.env.GATSBY_STORE === "us";

export const BabyListInitScript: FC = () => {
	return (
		<>
			<Script id="babylist_init_script" type="text/javascript">
				{`window._bl = { partner: 'babybjorn.com' };`}
			</Script>
			<Script
				id="babylist_add_script"
				async
				type="text/javascript"
				src="https://babylist.com/add.js"
			/>
		</>
	);
};

export const BabyListButton: FC<BabylistProductDetails> = (productDetails) => {
	const { t } = useTranslation();

	const addToBabylist = () => {
		if (window.bl !== undefined && window.bl.addToRegistry) {
			window.bl.addToRegistry(productDetails);
		}
	};
	return (
		<Button
			onClick={() => addToBabylist()}
			variant="outline"
			size="always-small"
			className="font-semibold"
		>
			{t("Add to Babylist registry")}
		</Button>
	);
};
